import HBButton from "@/components/HBButton";
import HBIcon from "@/components/HBIcon";
import CreativeExtensionButton from "./CreativeExtensionButton";
import styles from "./index.module.less";

export default function ArtButton({
  pin,
  searchWord,
  artLink,
}: {
  pin: IPin;
  searchWord?: string;
  artLink: string;
}) {
  return (
    <div className={styles.btns}>
      <CreativeExtensionButton pin={pin} searchWord={searchWord} />
      <HBButton
        className={styles.editBtn}
        href={artLink}
        data-gd-click="button_click"
        data-gd-expose="button_expose"
        data-button-name="做同款"
        data-search-word={searchWord}
        target="_blank"
        rel="nofollow"
        icon={<HBIcon type="edit_new" />}
        theme="gray"
      >
        编辑
      </HBButton>
    </div>
  );
}
